/** Request bounds. Responses may contain legacy values above these limits. */
export const STRING_MAX = {
  IDENTIFIER: 100,
  SHORT_TEXT: 200,
  LONG_TEXT: 2000,
  CREDENTIAL: 128,
  EMAIL: 254,
} as const;

export const CATALOG_MODEL_NAME_MAX_LENGTH = STRING_MAX.SHORT_TEXT;
export const DISCOUNT_NAME_MAX_LENGTH = STRING_MAX.SHORT_TEXT;
export const COMPANY_TAX_ID_MAX_LENGTH = 50;
export const INVITATION_CODE_MAX_LENGTH = 10;
